import React, { useState, useEffect } from 'react';
import estadosMunicipios from '../../components/estadosMunicipios.json';
import { limpiarCedula } from '../../components/limpiarCedula';
import { FECHA_NAC_MIN, FECHA_NAC_MAX } from '../../components/fechaNacimiento';
import axios from '../../axiosConfig';
import { Form, Button,Alert } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Select from 'react-select/async';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer, toast } from 'react-toastify';
import SelectComponent from '../../components/SelectComponent';
import { cohortesActivas } from '../../components/cohorteUtils';
import { Card, Row, Col } from 'react-bootstrap'; 
import { Modal, Table } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import InscribirCedula from './InscribirCedula.css';

const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado



// Datos propios de cada persona que van en su fila (pedido del 26/09/2026).
// Se llenan con la ficha del participante al buscar la cédula; los que ya
// tiene quedan bloqueados y los que le faltan son obligatorios y se guardan
// en su ficha al inscribir.
const CAMPOS_PERSONA = [
  ['grupo_prioritario_id', 'Grupo prioritario'],
  ['estado_id', 'Estado'],
  ['municipio', 'Municipio'],
  ['procedencia_id', 'Procedencia'],
  ['nivel_instruccion_id', 'Nivel de instrucción'],
];

const vacio = (v) => v === null || v === undefined || String(v).trim() === '';

const municipiosDe = (estadoId) =>
  estadosMunicipios.find((e) => String(e.id_estado) === String(estadoId))?.municipios || [];

const InscribirMasivoInterno = () => {
    const { cursoId } = useParams();
    const [cedula, setCedula] = useState('');
    const [datos, setDatos] = useState(null);
    const [curso, setCurso] = useState(null);
    const [error, setError] = useState('');
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores
    const [showModal, setShowModal] = useState(false);  // Estado para mostrar/ocultar modal
    const handleCloseModal = () => setShowModal(false); // Cierra el modal
    const [patrocinantes, setPatrocinantes] = useState([]); // Estado para lista de patrocinantes
    const [totalPages, setTotalPages] = useState(1);    // Total de páginas
    const [cedulaError, setCedulaError] = useState('');  // Estado para el mensaje de error si ya está inscrito
    const [isCedulaValid, setIsCedulaValid] = useState(true); // Estado para manejar si la cédula es válida
    const [formErrors, setFormErrors] = useState({}); // Estado para almacenar los mensajes de error
    const [patrocinanteSeleccionado1, setPatrocinanteSeleccionado1] = useState(null);
    const [patrocinanteSeleccionado2, setPatrocinanteSeleccionado2] = useState(null);
    const [patrocinanteSeleccionado3, setPatrocinanteSeleccionado3] = useState(null);
    // const [currentPatrocinante, setCurrentPatrocinanteIndex] = useState(null); // Para saber cuál botón abrió el modal
    const [currentPatrocinanteIndex, setCurrentPatrocinanteIndex] = useState(null);

    const [paginatedPatrocinantes, setPaginatedPatrocinantes] = useState([]); // Patrocinantes en la página actual

    const [currentPagePatrocinantes, setCurrentPagePatrocinantes] = useState(1);
    const userRole = localStorage.getItem('role');
      const [validated, setValidated] = useState(false);
    const [errorsAlert, setErrorsAlert] = useState([]); // array de mensajes
    
    
    const [filterOptions, setFilterOptions] = useState({
        cohorteOptions: [],
        periodoOptions: [],
        nivelInstruccionOptions: [],
        estadoOptions: [],
        generoOptions: [],
        grupoOptions: [],
        nacionalidadOptions: [],
        procedenciaOptions: [],
        superatecOptions: [],  
        centroOptions:[],
    });
      const [filterOptions2, setFilterOptions2] = useState({
        nivelInstruccionOptions: [],
        estadoOptions: [],
        generoOptions: [],
        grupoOptions: [],
        nacionalidadOptions: [],
        procedenciaOptions: [],
        superatecOptions: [],  
    });
    const [formData, setFormData] = useState({
        cohorte: '',
        periodo_id: '',
        observaciones:'',
        curso_id:'',
        centro_id:'',
        grupo:'',
   
    });
    const [filas, setFilas] = useState([
        {
          cedula_identidad: '',
          es_patrocinado:'',
          realiza_aporte:'',
          datos_identificacion_id:'',
          patrocinante_id:'',
          check:'',
          status_curso:'',
          status_pay:'',
        },
        {
            cedula_identidad: '',
            es_patrocinado:'',
            realiza_aporte:'',
            datos_identificacion_id:'',
            patrocinante_id:'',
            check:'',
            status_curso:'',
            status_pay:'',
          },
          {
            cedula_identidad: '',
            es_patrocinado:'',
            realiza_aporte:'',
            datos_identificacion_id:'',
            patrocinante_id:'',
            check:'',
            status_curso:'',
            status_pay:'',
          },
        
       
      ]); 
      
    
      // Agregar nueva fila
      const agregarFila = () => {
        setFilas([
          ...filas,
          {
            cedula_identidad: '',
            es_patrocinado:'',
            realiza_aporte:'',
            datos_identificacion_id:'',
            patrocinante_id:'',
            check:'',
            status_curso:'',
            status_pay:'',
            bloqueado: false // Bloquear edición

          },
        ]);
      };
    
      //  Eliminar la última fila
      const eliminarFila = () => {
        if (filas.length > 1) {
          setFilas(filas.slice(0, -1)); // Remueve la última fila
        }
      };
    


 

    const [filtrosPatrocinante, setFiltrosPatrocinante] = useState({
        rif_cedula:'',
        nombre_patrocinante: '',
    });
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    

    const handleFilterPatrocinantesChange = (e) => {
        const { name, value } = e.target;
        setFiltrosPatrocinante(prev => ({ ...prev, [name]: value }));
      };
      
      const handlePatrocinantesPageChange = async (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            await getAllPatrocinantes(newPage);
        }
      };

    
    const handleSeleccionarPatrocinante = (patrocinante) => {
        const nuevasFilas = [...filas];
        nuevasFilas[currentPatrocinanteIndex].patrocinante = patrocinante; // aquí guardas el objeto
        setFilas(nuevasFilas);
        handleCloseModal();
      };
      
      
    

    useEffect(() => {
        setLoading(true);
        Promise.all([fetchCurso(),handleSeleccionar(),handleSeleccionar2()]).finally(() => {
            setLoading(false);
        });
    }, [cursoId]);
    

    const fetchCurso = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/cursos/${cursoId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCurso(response.data);
        } catch (error) {
            console.error('Error fetching curso:', error);
            setError('Error fetching curso');
        }
    };

  
    

    const handleCedulaSearch = async (index) => {
        const selectedCedula = filas[index].cedula_identidad;
        if (!selectedCedula) return;
    
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/identificacion/${selectedCedula}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
            if (response.data) {
                let nuevoEstadoFilas = [...filas];
                nuevoEstadoFilas[index] = {
                    ...nuevoEstadoFilas[index],
                    nombres: response.data.nombres,
                    apellidos: response.data.apellidos,
                    fecha_nacimiento: response.data.fecha_nacimiento,
                    genero_id: response.data.genero_id,
                    direccion: response.data.direccion,
                    nivel_instruccion_id: response.data.nivel_instruccion_id,
                    direccion_email: response.data.direccion_email,
                    telefono_celular: response.data.telefono_celular,
                    grupo_prioritario_id: response.data.grupo_prioritario_id ?? '',
                    estado_id: response.data.estado_id ?? '',
                    municipio: response.data.municipio ?? '',
                    procedencia_id: response.data.procedencia_id ?? '',
                    // Lo que la ficha ya tenía: esos campos quedan bloqueados.
                    originales: Object.fromEntries(CAMPOS_PERSONA.map(([c]) => [c, response.data[c] ?? ''])),
                    datos_identificacion_id: response.data.id, // Asegurar que el ID esté presente
                    superatec: true, // Marca el checkbox automáticamente
                    errorMensaje: "",
                    bloqueado: true // Bloquear edición

                };
                setFilas(nuevoEstadoFilas);
            } else {
                let nuevoEstadoFilas = [...filas];
                nuevoEstadoFilas[index].errorMensaje = 'Cédula no encontrada en la base de datos';
                setFilas(nuevoEstadoFilas);
            }
        } catch (error) {
            let nuevoEstadoFilas = [...filas];
            nuevoEstadoFilas[index].errorMensaje = 'Error al buscar la cédula';
            setFilas(nuevoEstadoFilas);
        }
    };
    
    
    const handleCedulaInputChange = (event, index) => {
        let nuevoEstadoFilas = [...filas];
        let inputValue = limpiarCedula(event.target.value); // Dígitos (máx. 9) o cédula falsa F + dígitos
        nuevoEstadoFilas[index].cedula_identidad = inputValue;
        nuevoEstadoFilas[index].errorMensaje = "";
        setFilas(nuevoEstadoFilas);
    };
    
    const limpiarFila = (index) => {
        let nuevoEstadoFilas = [...filas];
        nuevoEstadoFilas[index] = {
            cedula_identidad: "",
            nombres: "",
            apellidos: "",
            fecha_nacimiento: "",
            genero_id: "",
            direccion: "",
            nivel_instruccion_id: "",
            grupo_prioritario_id: "",
            estado_id: "",
            municipio: "",
            procedencia_id: "",
            originales: null,
            es_patrocinado:'',
            realiza_aporte:'',
        };
        setFilas(nuevoEstadoFilas);
    };
    const handleSeleccionar = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/select-inc`, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            const { cohorte, periodo,centro,grupo } = response.data;
    
            // Guardar las opciones en el estado de filterOptions
            setFilterOptions({
                cohorteOptions: cohortesActivas(cohorte),
                periodoOptions: periodo,
                centroOptions:centro,
                grupoOptions:grupo,
            });
    
            setSelectVisible(true);  // Mostrar los selectores
        } catch (error) {
            console.error('Error fetching filter options:', error);
        }
    };
    const handleSeleccionar2 = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/filter-datos`, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            const {nivel_instruccion,estado,genero,grupo_prioritario,nacionalidad,procedencia,superatec} = response.data;
    
            // Guardar las opciones en el estado de filterOptions
            setFilterOptions2({
                nivelInstruccionOptions: nivel_instruccion,
                estadoOptions: estado,
                generoOptions: genero,
                grupoOptions:grupo_prioritario,
                nacionalidadOptions:nacionalidad,
                procedenciaOptions:procedencia,
                superatecOptions:superatec,
    
            });
    
            console.log("superatec",filterOptions.superatecOptions);
            console.log("procedencia",filterOptions.procedenciaOptions);
    
    
            setSelectVisible(true);  // Mostrar los selectores
        } catch (error) {
            console.error('Error fetching filter options:', error);
        }
    };


    const getAllPatrocinantes = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/patrocinantes-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filtrosPatrocinante, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.patrocinantes;
    
            // Actualizar el estado
            setPaginatedPatrocinantes(data); // Datos de la página actual
            setCurrentPagePatrocinantes(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
            setPatrocinantes(data);
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Error fetching data');
            setPaginatedPatrocinantes([]); // Limpia los datos en caso de error
            setPatrocinantes([]);
        }
    };

  
        const handleOpenModal = () => {
            getAllPatrocinantes(); // Cargar todos los patrocinantes
            setShowModal(true); // Mostrar el modal
        };


        const handleInscripcion = async (e) => {
              const form = e.currentTarget;        // el <form> que disparó el submit
            
               // validación manual extra para campos “custom”
              const requiredFields = ['cohorte','centro_id','periodo_id','grupo']; // agrega aquí los que no son nativos o te fallan
              const missing = requiredFields.filter(
                k => String(formData[k] ?? '').trim() === ''
              );
            
              // Valida required/pattern/min/max, etc.
              if (!form.checkValidity()) {
                e.stopPropagation();
                setValidated(true);
            
                // Crea listado legible de errores
                const invalids = Array.from(form.querySelectorAll(':invalid'));
                const msgs = invalids.map(el => {
                  const label =
                    el.getAttribute('aria-label') ||
                    el.labels?.[0]?.innerText ||
                    el.name || el.id || 'Campo';
                  const msg = el.validationMessage || 'Campo inválido';
                  return `${label}: ${msg}`;
                });
            
                setErrorsAlert(msgs);      // <-- muestra el Alert
                // opcional: toast también (asegúrate de tener <ToastContainer/> en tu app)
                // toast.error('Hay campos obligatorios sin completar.');
            
                setLoading(false);         // si habías puesto setLoading(true) antes
                invalids[0]?.focus();      // enfoca el primero inválido
                return;                    // corta el submit
              }
            
              // Si todo está ok, limpia alerta y sigue flujo normal
              setErrorsAlert([]);
              setValidated(true);
              setLoading(true);
              if (missing.length) {
                // toast.error('Completa los campos obligatorios.');
                setLoading(false);
                return;
              }
            
            
              setValidated(true);
              setLoading(true);
            const token = localStorage.getItem('token');

            // Antes este bucle no tenía try/catch: si una fila fallaba, lanzaba y
            // abortaba el resto. Las filas anteriores quedaban grabadas, las
            // siguientes no, y el usuario no veía ningún error. Ahora cada fila se
            // procesa de forma independiente y al final se informa el resultado.
            const inscritos = [];
            const fallidas  = [];

            for (const [indice, participante] of filas.entries()) {
                const numeroFila = indice + 1;

                // Las filas vacías entraban al bucle y creaban inscripciones con
                // datos_identificacion_id nulo: registros huérfanos e invisibles.
                if (!participante?.datos_identificacion_id) {
                  const tieneAlgo = String(participante?.cedula_identidad ?? '').trim() !== '';

                  if (tieneAlgo) {
                    fallidas.push(`Fila ${numeroFila} (${participante.cedula_identidad}): el participante no está registrado. Búsquelo con la lupa antes de inscribir.`);
                  }
                  continue; // fila vacía: se omite en silencio
                }

                // Los 5 datos de la persona son obligatorios.
                const faltan = CAMPOS_PERSONA.filter(([c]) => vacio(participante[c])).map(([, etiqueta]) => etiqueta);
                if (faltan.length) {
                  fallidas.push(`Fila ${numeroFila} (${participante.cedula_identidad}): falta ${faltan.join(', ')}.`);
                  continue;
                }

                // Lo que no estaba en la ficha del participante se guarda en ella.
                const completar = Object.fromEntries(
                  CAMPOS_PERSONA
                    .filter(([c]) => vacio(participante.originales?.[c]) && !vacio(participante[c]))
                    .map(([c]) => [c, participante[c]])
                );
                if (Object.keys(completar).length) {
                  try {
                    await axios.put(`/datos/${participante.datos_identificacion_id}`, completar, {
                      headers: { Authorization: `Bearer ${token}` },
                    });
                  } catch (error) {
                    const detalle = error.response?.data?.message || error.message || 'error desconocido';
                    fallidas.push(`Fila ${numeroFila} (${participante.cedula_identidad}): no se pudieron guardar sus datos (${detalle}).`);
                    continue;
                  }
                }

                const inscripcionPayload = {
                  ...formData,
                  cohorte: formData.cohorte,
                  periodo_id: formData.periodo_id,
                  centro_id: formData.centro_id,
                  es_patrocinado: participante.es_patrocinado,
                  realiza_aporte: participante.realiza_aporte,
                  patrocinante_id: participante.patrocinante?.id || null,
                  status_pay: participante.realiza_aporte === false && (!participante.es_patrocinado || participante.es_patrocinado === false) ? 5 : (participante.es_patrocinado === true ? 4 : 1),
                  status_curso: 1,
                  datos_identificacion_id: participante.datos_identificacion_id,
                  curso_id: cursoId,
                  status: true,
                  check:true,
                };

                try {
                  const response = await axios.post(`/cursos_inscripcion`, inscripcionPayload, {
                    headers: { Authorization: `Bearer ${token}` },
                  });

                  const inscripcionId = response.data.id;

                  // No admin y requiere pago: crear petición de pago
                  if (userRole !== 'admin' && participante.realiza_aporte === 'true' && (participante.es_patrocinado === 'false' || !participante.es_patrocinado)) {
                    await axios.post(`/peticiones`, {
                      zona_id: 3,
                      comentario: 'Pago no realizado',
                      user_id: userId,
                      role_id: 4,
                      status: false,
                      key: inscripcionId,
                    }, {
                      headers: { Authorization: `Bearer ${token}` },
                    });
                  }

                  inscritos.push(participante.cedula_identidad || `fila ${numeroFila}`);
                } catch (error) {
                  const detalle = error.response?.data?.message
                    || error.response?.data?.error
                    || error.message
                    || 'error desconocido';

                  fallidas.push(`Fila ${numeroFila} (${participante.cedula_identidad || 's/c'}): ${detalle}`);
                }
              }

            setLoading(false);

            if (fallidas.length > 0) {
              // Se informa el detalle y NO se navega, para que el usuario pueda
              // corregir las filas que quedaron pendientes.
              setErrorsAlert([
                `Inscritos: ${inscritos.length}. No se pudieron inscribir: ${fallidas.length}.`,
                ...fallidas,
              ]);

              if (inscritos.length > 0) {
                toast.warn(`${inscritos.length} inscritos, ${fallidas.length} con problemas`);
              } else {
                toast.error('No se pudo inscribir a ningún participante');
              }
              return;
            }

            if (inscritos.length === 0) {
              setErrorsAlert(['No había ninguna fila con un participante válido para inscribir.']);
              toast.error('No hay participantes que inscribir');
              return;
            }

            toast.success(`${inscritos.length} participantes inscritos con éxito`);
            navigate(`/inscritos/${cursoId}`);

        };
        
        

    // Celda de uno de los 5 datos de la persona. Sin cédula buscada: deshabilitada.
    // Si la ficha ya lo tenía: se muestra bloqueado. Si le falta: selector obligatorio.
    const opcionesDe = {
        grupo_prioritario_id: filterOptions2.grupoOptions,
        estado_id: filterOptions2.estadoOptions,
        procedencia_id: filterOptions2.procedenciaOptions,
        nivel_instruccion_id: filterOptions2.nivelInstruccionOptions,
    };
    const cambiarCampoPersona = (index, campo, valor) => {
        const nuevas = [...filas];
        nuevas[index] = { ...nuevas[index], [campo]: valor, ...(campo === 'estado_id' ? { municipio: '' } : {}) };
        setFilas(nuevas);
    };
    const renderCampoPersona = (fila, index, campo, etiqueta) => {
        const sinPersona = !fila.datos_identificacion_id;
        const bloqueado = !sinPersona && !vacio(fila.originales?.[campo]);
        const opciones = campo === 'municipio'
            ? municipiosDe(fila.estado_id).map((m) => ({ id: m.municipio, descripcion: m.municipio }))
            : (opcionesDe[campo] || []);

        if (bloqueado) {
            const texto = campo === 'municipio'
                ? fila.municipio
                : (opciones.find((o) => String(o.id) === String(fila[campo]))?.descripcion ?? fila[campo]);
            return <Form.Control type="text" value={texto} readOnly title={etiqueta} />;
        }
        return (
            <Form.Select
                value={fila[campo] ?? ''}
                onChange={(e) => cambiarCampoPersona(index, campo, e.target.value)}
                disabled={sinPersona || (campo === 'municipio' && vacio(fila.estado_id))}
                isInvalid={!sinPersona && vacio(fila[campo])}
                aria-label={etiqueta}
                title={sinPersona ? 'Busque primero la cédula' : `${etiqueta} (falta en su ficha)`}
            >
                <option value="">{sinPersona ? '—' : 'Seleccione'}</option>
                {opciones.map((o) => <option key={o.id} value={o.id}>{o.descripcion}</option>)}
            </Form.Select>
        );
    };

    return (
        <div className="row" style={{ marginTop: '50px' }}>
        <div className="col-lg-11 mx-auto"> {/* Centrado del contenido */}
           {errorsAlert.length > 0 && (
  <Alert variant="danger" dismissible onClose={() => setErrorsAlert([])}>
    <strong>Corrige los siguientes campos:</strong>
    <ul className="mb-0">
      {errorsAlert.map((m, i) => <li key={i}>{m}</li>)}
    </ul>
  </Alert>
)}
      <Form noValidate validated={validated} onSubmit={(e) => handleInscripcion(e)}>
       
        <Form.Group controlId="cedula" className="custom-gutter" >
          <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
            <h1>Inscripción Masiva a  {curso && `  ${curso.descripcion}`} ({curso && `  ${curso.cod}`})</h1>
            <div>
            </div>
           
                <div className="mt-3">
                    <Row className="g-2">
                        <Col md={2}>
                    {/* Cohorte Selector */}
                    {formErrors.cohorte && (
                    <div className="text-danger">{formErrors.cohorte}</div>
                )}
                    <SelectComponent
                        options={filterOptions.cohorteOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData.cohorte}
                        handleChange={handleChange}
                        controlId="cohorte"
                        label="Cohorte"
                        required
                    />
                    </Col>
                    <Col md={2}>

                    {/* Centro Selector */}
                    {formErrors.centro_id && (
                    <div className="text-danger">{formErrors.centro_id}</div>
                    
                )}
                 <SelectComponent
                        options={filterOptions.centroOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData.centro_id}
                        handleChange={handleChange}
                        controlId="centro_id"
                        label="Centro"
                        required

                    />
                    </Col>
                   
                   <Col md={2}>
                    {/* Periodo Selector */}
                    {formErrors.periodo_id && (
                    <div className="text-danger">{formErrors.periodo_id}</div>
                )}
                    <SelectComponent
                        options={filterOptions.periodoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData.periodo_id}
                        handleChange={handleChange}
                        controlId="periodo_id"
                        label="Periodo"
                        required

                    />
                    </Col>
                    <Col md={2}>
                    {/* Periodo Selector */}
                    {formErrors.periodo_id && (
                    <div className="text-danger">{formErrors.periodo_id}</div>
                )}
                    <SelectComponent
                        options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData.grupo}
                        handleChange={handleChange}
                        controlId="grupo"
                        label="Grupo"
                        required

                    />
                    </Col>
                 
                        
                    
                            </Row>
                            
                        <Form.Group controlId="observaciones">
                        <Form.Label>Observaciones</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                        />
                        </Form.Group>

                        <div className="d-flex align-items-center gap-2 flex-wrap mt-3">


                         {/* Tabla de Datos */}
                         {/* Con 13 columnas la tabla no entra en la pantalla: cada columna
                             tiene un ancho mínimo y la tabla se desplaza hacia los lados
                             en vez de aplastarse (antes la cédula no se veía). */}
                         <div style={{ width: '100%', overflowX: 'auto' }}>
                         <Table bordered striped className="mb-0" style={{ minWidth: '2250px', fontSize: '0.9rem' }}>

        <thead>
          <tr>
            <th style={{ minWidth: '210px' }}>Cédula</th>
            <th style={{ minWidth: '170px' }}>Nombre</th>
            <th style={{ minWidth: '170px' }}>Apellido</th>
            <th style={{ minWidth: '150px' }}>Fecha Nac.</th>
            <th style={{ minWidth: '180px' }}>Grupo prioritario</th>
            <th style={{ minWidth: '160px' }}>Estado</th>
            <th style={{ minWidth: '190px' }}>Municipio</th>
            <th style={{ minWidth: '220px' }}>Procedencia</th>
            <th style={{ minWidth: '200px' }}>Nivel de instrucción</th>
            <th style={{ minWidth: '130px' }}>Es patrocinado</th>
            <th style={{ minWidth: '130px' }}>Realiza Aporte</th>
            <th style={{ minWidth: '220px' }}>Patrocinante</th>
            <th style={{ minWidth: '80px' }} className="text-center">Limpiar</th>
          </tr>
        </thead>
        <tbody>
          {filas.map((fila, index) => (
            <tr key={index}>
              <td>
              <Form.Group controlId={`cedula-${index}`} className="custom-gutter d-flex align-items-center">
                            <input
                                type="text"
                                value={fila.cedula_identidad}
                                onChange={(event) => handleCedulaInputChange(event, index)}
                                placeholder="Cédula"
                                className="form-control flex-grow-1"
                                style={{ minWidth: 0 }}
                                maxLength="9"
                            />
                            <button type="button" onClick={() => handleCedulaSearch(index)} className="btn btn-primary ms-1 px-2"
                                style={{ flex: '0 0 42px', width: '42px' }} title="Buscar cédula">
                                <i className="bi bi-search"></i>
                            </button>
                        </Form.Group>
                        {fila.errorMensaje && <div className="text-danger mt-1">{fila.errorMensaje}</div>}
                    </td>
              <td>
                <Form.Control
                  type="text"
                  name="nombres"
                  value={fila.nombres}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].nombres = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}

                  readOnly
                  maxLength={255}
                  placeholder="Nombre"
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="apellidos"
                  value={fila.apellidos}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].apellidos = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                  readOnly
                  maxLength={255}
                  placeholder="Apellido"
                />
              </td>
              <td>
                <Form.Control
                  type="date"
                  name="fecha_nacimiento"
                  min={FECHA_NAC_MIN}
                  max={FECHA_NAC_MAX}
                  readOnly

                  value={fila.fecha_nacimiento}
                  onChange={(e) => {
                    if (!filas[index].bloqueado) {
                    const nuevasFilas = [...filas];
                    nuevasFilas[index].fecha_nacimiento = e.target.value;
                    setFilas(nuevasFilas);
                    }
                  }}
                />
              </td>
              {CAMPOS_PERSONA.map(([campo, etiqueta]) => (
                <td key={campo}>
                  {renderCampoPersona(fila, index, campo, etiqueta)}
                </td>
              ))}

                <td>
                <Form.Control
                    as="select"
                    value={String(filas[index].es_patrocinado ?? '')}
                    onChange={(e) => {
                        const val = e.target.value === 'true' ? true
                                : e.target.value === 'false' ? false
                                : null; // "" -> null
                        const nuevas = [...filas];
                        nuevas[index] = { ...nuevas[index], es_patrocinado: val };
                        setFilas(nuevas);
                    }}
                    >
                    <option value="">Seleccione</option>
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                    </Form.Control>
                </td>
                <td>
               <Form.Control
                    as="select"
                    value={String(filas[index].realiza_aporte ?? '')}
                    onChange={(e) => {
                        const val = e.target.value === 'true' ? true
                                : e.target.value === 'false' ? false
                                : null;
                        const nuevas = [...filas];
                        nuevas[index] = { ...nuevas[index], realiza_aporte: val };
                        setFilas(nuevas);
                    }}
                    >
                    <option value="">Seleccione</option>
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                    </Form.Control>
                </td>

              <td>
                <Form.Control 
                    type="text" 
                    // value={patrocinanteSeleccionado1 ? patrocinanteSeleccionado1.nombre_patrocinante : 'No seleccionado'} 
                    value={fila.patrocinante ? fila.patrocinante.nombre_patrocinante : 'No seleccionado'}
                    readOnly
                    className="mb-1"
                    title={fila.patrocinante ? fila.patrocinante.nombre_patrocinante : 'No seleccionado'}
                />
                <Button variant="secondary" size="sm" className="w-100" onClick={() => {
                    setCurrentPatrocinanteIndex(index);
                    handleOpenModal();
                    }}>
                    {fila.patrocinante ? 'Cambiar' : 'Seleccionar'}

                    </Button>

                {patrocinanteSeleccionado1 && (
                    <Button variant="danger" onClick={() => setPatrocinanteSeleccionado1(null)} className="ms-2">
                        Deseleccionar
                    </Button>
                )}
                </td>
              
                    <td>
                    <button type="button" onClick={() => limpiarFila(index)} className="btn btn-warning ms-2">
                                <i className="bi bi-brush-fill"></i>
                            </button>
                    </td>
            </tr>
            
          ))}
        </tbody>
      </Table>
                         </div>

      {/* Botones de Acción */}
      <div className="d-flex justify-content-between mt-3">
        <Button variant="success" onClick={agregarFila}>
          Agregar Fila
        </Button>
        <Button variant="danger" onClick={eliminarFila} disabled={filas.length === 1} className="ms-3">
             Eliminar Fila
            </Button>
      </div>
                    </div>
                            </div>

                   
                            <div className="d-flex mt-1">
                                <Button variant="info" onClick={handleInscripcion} className="mt-3 me-2">
                                    Inscribir
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={() => navigate(-1)}
                                    className="mt-3"
                                >
                                    Volver
                                </Button>
                            </div>
                    </div>
                    </Form.Group>
                    </Form>
                    </div>
                    
                    <Modal show={showModal} onHide={handleCloseModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Seleccionar Patrocinante</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div className="d-flex align-items-center">

                        <Form.Control 
                            name="rif_cedula"
                            type="text" 
                            placeholder="Buscar por Rif/Cédula" 
                            value={filtrosPatrocinante.rif_cedula}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Form.Control 
                            name="nombre_patrocinante"
                            type="text" 
                            placeholder="Buscar por Nombre" 
                            value={filtrosPatrocinante.nombre_patrocinante}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Button 
                            variant="info me-2" 
                            onClick={getAllPatrocinantes}
                            style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                        >
                            <FaSearch className="me-1" /> {/* Ícono de lupa */}
                        </Button>

                    </div>

                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Rif/Cédula</th>
                                    <th>Nombre</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {paginatedPatrocinantes.map((patrocinante) => (
                                    <tr key={patrocinante.id}>
                                        <td>{patrocinante.rif_cedula}</td>
                                        <td>{patrocinante.nombre_patrocinante}</td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Button variant="info" onClick={() => handleSeleccionarPatrocinante(patrocinante)} className="me-2">
                                                    <i className="bi bi-check2-square"></i>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <div className="d-flex justify-content-between mt-3">
                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes - 1)}
                                disabled={currentPagePatrocinantes === 1}
                            >
                                Anterior
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes + 1)}
                                disabled={currentPagePatrocinantes === totalPages}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
</div>
        
    );
};
export default InscribirMasivoInterno;
